import axios from '../api';
import store from '../store';
import Constants from './../constants';
import Permissions from '../mixins/PermissionsHelpers.vue';

export default {
  namespaced: true,

  state: {
    tabDisplay: 'informations',

    datas:{},
    listRoles:[],

    billingHistory: [],

    isAdminPay: false,
    isReferent: false,
    inCompany: false,

    saving: false,
    messageHeader: null,
    showContactOfferPopup: false,

    errors: null,
  },

  getters: {
    tabDisplay(state){
      return state.tabDisplay;
    },
    isAdminPay(state){
      return state.isAdminPay;
    },
    isReferent(state){
      return state.isReferent;
    },
    inCompany(state){
      return state.inCompany;
    },
    saving(state){
      return state.saving;
    },
    messageHeader(state){
      return state.messageHeader;
    },
    datas(state){
      return state.datas;
    },

    listRoles(state){
      return state.listRoles;
    },
    billingHistory(state){
      return state.billingHistory;
    },
    errors(state){
      return state.errors;
    }
  },

  mutations: {
    SET_TABDISPLAY(state, tab){
      state.tabDisplay = tab;
    },
    SET_ISADMINPAY(state, bool){
      state.isAdminPay = bool;
    },
    SET_ISREFERENT(state, bool){
      state.isReferent = bool;
    },
    SET_INCOMPANY(state, bool){
      state.inCompany = bool;
    },
    SET_SAVING(state, bool){
      state.saving = bool;
    },
    SET_MESSAGEHEADER(state, msg){
      state.messageHeader = msg;
    },
    SET_DATAS(state, data){
      state.datas = data;
    },
    SET_SHOW_CONTACT_OFFER_POPUP(state, show) {
      state.showContactOfferPopup = show;
    },

    SET_LISTROLES(state, list){
      state.listRoles = list;
    },
    SET_BILLINGHISTORY(state, list){
      state.billingHistory = list;
    },
    SET_ERRORS(state, err){
      state.errors = err;
    }
  },
  actions: {

    /**
         * retrieve all auth user account informations
         * @param {*} context 
         */
    async loadInformations(context){
      console.log('wait...load informations');
            
      //refresh account datas
      await store.dispatch('auth/me');
      let user = store.getters['auth/user'];

      if(Permissions.methods.$freeParticulier()){
        context.commit('SET_DATAS', {
          username: user.username,
          firstname: user.firstname,
          lastname: user.lastname,
          email: user.email,
          phone_number : user.phone_number,
          address: user.address,
          company: '',
          type_company: '',
          siret: '',
          ape: '',
          role:'',
        });
        return; 
      }

      //retrieve user informations
      await axios.get('/api/users/company/'+user.id).then((response) => {
        context.commit('SET_DATAS', {
          username: user.username,
          firstname: user.firstname,
          lastname: user.lastname,
          email: user.email,
          phone_number : user.phone_number,
          address: user.address,
          company: response.data.name,
          type_company:response.data.type,
          siret: response.data.siret,
          ape: response.data.ape,
          position: response.data.company_user.position
        });

        //retrieve user function (not for PARTICULIER user)
        if(context.getters.datas.company != '' && context.getters.datas.type_company != Constants.TYPE_PARTICULIER){
          //context.getters.datas.function = response.data.pivot.function;
          context.commit('SET_INCOMPANY', true);
        }
      });

      //refresh default role and indicate if user is referent or not
      await axios.get('/api/role/name').then((response) => {
        context.getters.datas.role = response.data;
      });
      let role = store.getters['auth/role'];
      context.commit('SET_ISREFERENT', role == Constants.ROLE_REFERENT);
    },

    /**
         * Verify if auth user has admin payer role
         * 
         * @param {*} context 
         */
    async isPayer(context){
      if(store.getters['auth/role'] == Constants.ROLE_ADMIN_PAYEUR || store.getters['auth/user'].isParticulier){
        context.commit('SET_ISADMINPAY', true);
      }
      else{
        await axios.get('/api/existsPayer').then((response) => {
          if(response.data){
            context.commit('SET_ISADMINPAY', false);
          }else{ //user is payer if not exists admin payer in company
            context.commit('SET_ISADMINPAY', true);
          }
        });
      }
    },

    /**
         * Save all form filled informations in account page
         * @param {*} context 
         */
    async save_infos(context){
      //Set loading animation
      context.commit('SET_SAVING', true);

      let user = store.getters['auth/user'];

      let infos = {
        firstname: context.getters.datas.firstname,
        lastname: context.getters.datas.lastname,
        email: context.getters.datas.email,
        phone_number: context.getters.datas.phone_number,
        address: context.getters.datas.address,
        company: context.getters.datas.company,
      };

      if(context.getters.inCompany){
        infos.position = context.getters.datas.position;
      }

      if(context.getters.isAdminPay){
        infos.siret = context.getters.datas.siret;
        infos.ape = context.getters.datas.ape;
      }

      if(context.getters.isReferent){
        infos.role = context.getters.datas.role;
      }

      if(context.getters.datas.password != ''){
        infos.password = context.getters.datas.password;
      }

      await axios.put('/api/users/'+user.id, {user: infos}).then(() => {
        //stop loading animation
        context.commit('SET_SAVING', false);
        //set success message to display on page
        context.commit('SET_MESSAGEHEADER', {type: 'success', msg: 'Les informations ont bien été enregistrées.'});
        //no error
        context.commit('SET_ERRORS', null);
        //Success message disapear after 3 secondes
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
      }).catch(error => {
        //Set errors (ex : required field not filled)
        context.commit('SET_ERRORS', error.response.data.errors);
        //set error message to display on page
        context.commit('SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d\'enregistrement des données.'});
        //Error message disapear after 3 secondes
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
        //stop loading animation
        context.commit('SET_SAVING', false);
      });
    },

    /**
         * Save the new password with confirm password and authentication password
         * @param {*} context 
         * @param Object datas 
         */
    async saveNewPassword(context, datas){
      //Set loading animation
      context.commit('SET_SAVING', true);

      let user = store.getters['auth/user'];

      await axios.post('/api/users/changePassword/'+user.id,
        {
          newPassword: {
            password: datas.accountDatas.password,
            password_confirmation: datas.accountDatas.password_confirmation,
          },
          authPassword: datas.authPassword,
        }).then((response) => {
        //set success message to display on page
        context.commit('SET_MESSAGEHEADER', {type: 'success', msg: response.data.msg});
        //Success message disapear after 3 secondes
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
        //stop loading animation
        context.commit('SET_SAVING', false);
        //no error
        context.commit('SET_ERRORS', null);
      }).catch(error => {
        //Error 403 : Forbidden
        if(error.response.status === 403){
          context.commit('SET_ERRORS', {authPassword:[error.response.data.msg]});
        }
        else{ //form fields errors
          context.commit('SET_ERRORS', error.response.data.errors);
        }
        context.commit('SET_SAVING', false);
      });
    },

    /**
         * get billing history
         * @param {*} context 
         * @returns 
         */
    async getBillingHistory(){
      return await axios.get('/api/billing_history/').then((response) => {
        return response.data;
      }).catch(error => console.log(error));
    }
  }
};